import { onDomReady } from '../../components/dynamic/observer';
import Offices from './Offices';

onDomReady(() => {
  new Offices(document.querySelector('[data-offices]'));
});
